module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-13-e3a9f185c27108b9aaa2bd2f7fae39aa.jpg";